import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Query } from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, RowDeselectEventArgs, RowSelectEventArgs, SelectionSettingsModel, ToolbarItems, SelectionService } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { GridPageSettings, DialogExpensaGastosPeriodoComponentRequestDto, DialogExpensaGastosPeriodoComponentResponseDto, SaveGastosPeriodoRequestDto, ComunidadTiposGastos, ServicioGasto, Moneda, SearchPendientesLiquidacionRequest, SearchServicioGastoRequest, SearchMonedaRequest } from '../../../../../src/app/shared/model';
import { ComunidadService, ExpensaService, GastoService, MonedaService, ServicioGastoService } from '../../../../../src/app/shared/services';

import { DialogExpensaLiquidacionSimulacionComponent } from './dialogExpensaLiquidacionSimulacion.component';

@Component({
  selector: 'app-dialogExpensaGastosPeriodo',
  templateUrl: 'dialogExpensaGastosPeriodo.component.html',
  styleUrls: ['./dialogExpensaGastosPeriodo.component.css'],
  providers: [SelectionService]
})

export class DialogExpensaGastosPeriodoComponent implements OnInit {

  @ViewChild('gastosComunidadGrid')
  public gastosComunidadGrid: GridComponent;
  @ViewChild('gastosUfsGrid')
  public gastosUfsGrid: GridComponent;

  @ViewChild('gastosComunidadPeriodoGrid')
  public gastosComunidadPeriodoGrid: GridComponent;
  @ViewChild('gastosUfsPeriodoGrid')
  public gastosUfsPeriodoGrid: GridComponent;

  formGroup: FormGroup;

  comunidadTipoGastoList: ComunidadTiposGastos[];
  serviciosList: ServicioGasto[];
  monedaList: Moneda[];

  gastosComunidadPendientesList: any[]; //SearchPendientesLiquidacionItem[];
  gastosUfPendientesList: any[]; //SearchPendientesLiquidacionItem[];

  gastosComunidadPeriodoList: any[]; //SearchPendientesLiquidacionItem[];
  gastosUfPeriodoList: any[]; //SearchPendientesLiquidacionItem[];

  cantidadGastosTotalSeleccionado: number = 0;
  gastosTotalSeleccionado: number = 0;
  cantidadGastosComunidadTotalSeleccionado: number = 0;
  gastosComunidadTotalSeleccionado: number = 0;
  cantidadGastosUfTotalSeleccionado: number = 0;
  gastosUfTotalSeleccionado: number = 0;

  verOtrosGastosPendientes: boolean = false;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSimulating: boolean = false;
  isSaving: boolean = false;

  isGastoSearching: boolean = false;
  isTipoGastoComunidadSearching: boolean = false;
  isMonedaSearching: boolean = false;
  isServicioSearching: boolean = false;

  public gastosSelectionOptions: SelectionSettingsModel;
  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;
  public ufGridPageSettings: PageSettingsModel;
  public ufGridAllowPaging: boolean = true;
  public gastosGridPageSettings: PageSettingsModel;
  public gastosGridAllowPaging: boolean = true;

  public query: Query;

  constructor(
    private dialogRef: MatDialogRef<DialogExpensaGastosPeriodoComponent>,
    @Inject(MAT_DIALOG_DATA) public input: DialogExpensaGastosPeriodoComponentRequestDto,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private gastoService: GastoService,
    private monedaService: MonedaService,
    private comunidadService: ComunidadService,
    private servicioGastoService: ServicioGastoService,
    private expensaService: ExpensaService
  ) {
    this.gastosSelectionOptions = { persistSelection: true, type: 'Multiple', checkboxOnly: true };
  }

  ngOnInit(): void {
    this.loadView();
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    this.ufGridPageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };
    this.gastosGridPageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };

    this.gastosComunidadPeriodoList = (this.input?.GastosPeriodo as any[])?.filter(f => f.UnidadFuncionalId == null);
    this.gastosUfPeriodoList = (this.input?.GastosPeriodo as any[])?.filter(f => f.UnidadFuncionalId > 0);
    this.updateGastoTotal();

    this.buildForm();

    this.getTiposGastosByComunidad();
    this.getServicios();
    this.getMonedas();

    this.onGastoSearch();
  }

  onGastoSearch() {
    if ((this.gastosComunidadPendientesList != null && this.gastosComunidadPendientesList.length > 0 && this.gastosComunidadPendientesList.some(f => f.Seleccionado == true)) &&
        (this.gastosUfPendientesList != null && this.gastosUfPendientesList.length > 0 && this.gastosUfPendientesList.some(f => f.Seleccionado == true)))
      return false;

    var serviciosString = (this.formGroup.get("Servicios")?.value as number[])?.join(",");
    var fechaExpensaDate = new Date(this.input?.ExpensaCabecera?.FechaExpensa);
    var fechaBusquedaGasto = new Date(fechaExpensaDate.getFullYear(), fechaExpensaDate.getMonth() - 1, 1);

    var r = new SearchPendientesLiquidacionRequest(null, null, true, "FechaGasto", fechaBusquedaGasto,
        this.input?.ExpensaCabecera.ConsorcioId, this.input?.ExpensaCabecera.ComunidadId, this.formGroup.get("TipoGastoId")?.value,
        this.formGroup.get("MonedaId")?.value, serviciosString, [], this.verOtrosGastosPendientes,
        this.formGroup.get("FechaGastoDesde")?.value, this.formGroup.get("FechaGastoHasta")?.value);

    this.isGastoSearching = true;
    this.gastoService.searchPendientesLiquidacion(r).subscribe(data => {
      this.isGastoSearching = false;

      var seleccionados = this.gastosComunidadPendientesList?.filter(f => f.Seleccionado == true);
      if (seleccionados != null && seleccionados.length > 0) {
        for (var i=0; i<seleccionados.length; i++)
          this.gastosComunidadPendientesList.find(f => f.Id == seleccionados[i].Id).Seleccionado = false;
      }

      var seleccionados2 = this.gastosUfPendientesList?.filter(f => f.Seleccionado == true);
      if (seleccionados2 != null && seleccionados2.length > 0) {
        for (var i=0; i<seleccionados2.length; i++)
          this.gastosUfPendientesList.find(f => f.Id == seleccionados2[i].Id).Seleccionado = false;
      }

      this.gastosComunidadPendientesList = data?.result?.filter(f => f.UnidadFuncionalId == null);
      this.gastosUfPendientesList = data?.result?.filter(f => f.UnidadFuncionalId > 0);

      this.updateGastoTotal();
    },
    (err: HttpErrorResponse) => {
      this.isGastoSearching = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  getTiposGastosByComunidad() {
    this.isTipoGastoComunidadSearching = true;
    this.comunidadService.getTiposGasto(this.input?.ExpensaCabecera?.ComunidadId).subscribe(data => {
      this.isTipoGastoComunidadSearching = false;
      this.comunidadTipoGastoList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoGastoComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMonedas() {
    var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(r).subscribe(data => {
      this.isMonedaSearching = false;
      this.monedaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getServicios() {
    var r = new SearchServicioGastoRequest(null, null, true, "Nombre", null, null, null, null, true);
    this.isServicioSearching = true;

    this.servicioGastoService.search(r).subscribe(data => {
      this.isServicioSearching = false;
      if (data != null)
        this.serviciosList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isServicioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  compareServicios(o1: number, o2: number): boolean {
    return o1 == o2;
  }

  onGastoComunidadDataBound(args: any) {
    this.actualizarGastoComunidadSeleccionados();
  }

  actualizarGastoComunidadSeleccionados() {
    var seleccionados = this.gastosComunidadPendientesList?.filter(f => f.Seleccionado == true);

    // Restaurar la selección de filas
    if (seleccionados != null && seleccionados.length > 0) {
      var pageRows = this.gastosComunidadGrid.getRowsObject();
      if (pageRows != null && pageRows.length > 0) {
        var indexes: number[] = [];
        for (var i=0; i<pageRows.length; i++) {
          if (seleccionados.some(f => f.Id == (pageRows[i].data as any).Id))
            indexes.push(pageRows[i].index);
        }

        if (indexes != null && indexes.length > 0)
          this.gastosComunidadGrid.selectRows(indexes);
      }
    }
  }

  onGastoComunidadRowSelected(args: RowSelectEventArgs) {
    if (args.isHeaderCheckboxClicked) {
      for (var i=0; i<this.gastosComunidadPendientesList.length; i++) {
        this.gastosComunidadPendientesList[i].Seleccionado = true;
        this.addGastoComunidadPeriodo(this.gastosComunidadPendientesList[i]);
      }
    }
    else {
      if (args?.data != null && (args?.data as any).Id != null) {
        this.gastosComunidadPendientesList.find(f => f.Id == (args?.data as any).Id).Seleccionado = true;
        this.addGastoComunidadPeriodo(this.gastosComunidadPendientesList.find(f => f.Id == (args?.data as any).Id));
      }
    }

    this.updateGastoTotal();
  }

  onGastoComunidadRowDeselected(args: RowDeselectEventArgs) {
    //Solo cuando hace click en el checkbox de la grilla deselecciona
    if (args.isHeaderCheckboxClicked) {
      for (var i=0; i<this.gastosComunidadPendientesList.length; i++) {
        this.gastosComunidadPendientesList[i].Seleccionado = false;
        this.deleteGastoComunidadPeriodo(this.gastosComunidadPendientesList[i]);
      }
    }
    else {
      if (args?.data != null  && (args?.data as any).Id != null && args?.target?.className == "e-frame e-icons e-uncheck") {
        this.gastosComunidadPendientesList.find(f => f.Id == (args?.data as any).Id).Seleccionado = false;
        this.deleteGastoComunidadPeriodo(this.gastosComunidadPendientesList.find(f => f.Id == (args?.data as any).Id));
      }
    }

    this.updateGastoTotal();
  }

  onGastoUfDataBound(args: any) {
    this.actualizarGastoUfSeleccionados();
  }

  actualizarGastoUfSeleccionados() {
    var seleccionados = this.gastosUfPendientesList?.filter(f => f.Seleccionado == true);

    // Restaurar la selección de filas
    if (seleccionados != null && seleccionados.length > 0) {
      var pageRows = this.gastosUfsGrid.getRowsObject();
      if (pageRows != null && pageRows.length > 0) {
        var indexes: number[] = [];
        for (var i=0; i<pageRows.length; i++) {
          if (seleccionados.some(f => f.Id == (pageRows[i].data as any).Id))
            indexes.push(pageRows[i].index);
        }

        if (indexes != null && indexes.length > 0)
          this.gastosUfsGrid.selectRows(indexes);
      }
    }
  }

  onGastoUfRowSelected(args: RowSelectEventArgs) {
    if (args.isHeaderCheckboxClicked) {
      for (var i=0; i<this.gastosUfPendientesList.length; i++) {
        this.gastosUfPendientesList[i].Seleccionado = true;
        this.addGastoUfPeriodo(this.gastosUfPendientesList[i]);
      }
    }
    else {
      if (args?.data != null && (args?.data as any).Id != null) {
        this.gastosUfPendientesList.find(f => f.Id == (args?.data as any).Id).Seleccionado = true;
        this.addGastoUfPeriodo(this.gastosUfPendientesList.find(f => f.Id == (args?.data as any).Id));
      }
    }

    this.updateGastoTotal();
  }

  onGastoUfRowDeselected(args: RowDeselectEventArgs) {
    //Solo cuando hace click en el checkbox de la grilla deselecciona
    if (args.isHeaderCheckboxClicked) {
      for (var i=0; i<this.gastosUfPendientesList.length; i++) {
        this.gastosUfPendientesList[i].Seleccionado = false;
        this.deleteGastoUfPeriodo(this.gastosUfPendientesList[i]);
      }
    }
    else {
      if (args?.data != null  && (args?.data as any).Id != null && args?.target?.className == "e-frame e-icons e-uncheck") {
        this.gastosUfPendientesList.find(f => f.Id == (args?.data as any).Id).Seleccionado = false;
        this.deleteGastoUfPeriodo(this.gastosUfPendientesList.find(f => f.Id == (args?.data as any).Id));
      }
    }

    this.updateGastoTotal();
  }

  updateGastoTotal() {
    this.gastosTotalSeleccionado = 0;
    this.cantidadGastosTotalSeleccionado = 0;
    this.gastosComunidadTotalSeleccionado = 0;
    this.cantidadGastosComunidadTotalSeleccionado = 0;
    this.gastosUfTotalSeleccionado = 0;
    this.cantidadGastosUfTotalSeleccionado = 0;

    var itemList = this.gastosComunidadPeriodoList;
    if (itemList != null && itemList.length > 0) {
      this.gastosComunidadTotalSeleccionado = (itemList?.reduce(function (accumulator, item) {
        return accumulator + (item?.Importe ?? 0);
      }, 0) ?? 0);
    }

    var itemList2 = this.gastosUfPeriodoList;
    if (itemList2 != null && itemList2.length > 0) {
      this.gastosUfTotalSeleccionado = (itemList2?.reduce(function (accumulator, item) {
        return accumulator + (item?.Importe ?? 0);
      }, 0) ?? 0);
    }

    this.gastosTotalSeleccionado = this.gastosComunidadTotalSeleccionado + this.gastosUfTotalSeleccionado;

    this.cantidadGastosComunidadTotalSeleccionado = (itemList?.length ?? 0);
    this.cantidadGastosUfTotalSeleccionado = (itemList2?.length ?? 0);
    this.cantidadGastosTotalSeleccionado = (itemList?.length ?? 0) + (itemList2?.length ?? 0);
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'TipoGastoId': [null],
      'MonedaId': [null],
      'Servicios': [null],
      'FechaGastoDesde': [null],
      'FechaGastoHasta': [null]
    });
  }

  addGastoComunidadPeriodo(item: any) {
    if (this.gastosComunidadPeriodoList == null)
      this.gastosComunidadPeriodoList = [];

    if (item != null && item.Id  > 0) {
      var index = this.gastosComunidadPeriodoList.findIndex(f => f.Id == item.Id);
      if (index < 0) {
        item.Nuevo = true;
        this.gastosComunidadPeriodoList.push(item);

        if (this.gastosComunidadPeriodoGrid != null)
          this.gastosComunidadPeriodoGrid.refresh();

        this.updateGastoTotal();
      }
    }
  }

  addGastoUfPeriodo(item: any) {
    if (this.gastosUfPeriodoList == null)
      this.gastosUfPeriodoList = [];

    if (item != null && item.Id  > 0) {
      var index = this.gastosUfPeriodoList.findIndex(f => f.Id == item.Id);
      if (index < 0) {
        item.Nuevo = true;
        this.gastosUfPeriodoList.push(item);

        if (this.gastosUfsPeriodoGrid != null)
          this.gastosUfsPeriodoGrid.refresh();

        this.updateGastoTotal();
      }
    }
  }

  deleteGastoComunidadPeriodo(item: any) {
    if (this.gastosComunidadPeriodoList == null)
      this.gastosComunidadPeriodoList = [];

    if (item != null && item.Id  > 0) {
      var index = this.gastosComunidadPeriodoList.findIndex(f => f.Id == item.Id);
      if (index >= 0) {
        if (this.gastosComunidadPeriodoList[index].Nuevo) {
          this.gastosComunidadPendientesList.find(f => f.Id == item.Id).Seleccionado = false;
          this.gastosComunidadGrid.refresh();
        }

        this.gastosComunidadPeriodoList.splice(index, 1);

        if (this.gastosComunidadPeriodoGrid != null)
          this.gastosComunidadPeriodoGrid.refresh();

        this.updateGastoTotal();
      }
    }
  }

  deleteGastoUfPeriodo(item: any) {
    if (this.gastosUfPeriodoList == null)
      this.gastosUfPeriodoList = [];

    if (item != null && item.Id  > 0) {
      var index = this.gastosUfPeriodoList.findIndex(f => f.Id == item.Id);
      if (index >= 0) {
        if (this.gastosUfPeriodoList[index].Nuevo) {
          this.gastosUfPendientesList.find(f => f.Id == item.Id).Seleccionado = false;
          this.gastosUfsGrid.refresh();
        }

        this.gastosUfPeriodoList.splice(index, 1);

        if (this.gastosUfsPeriodoGrid != null)
          this.gastosUfsPeriodoGrid.refresh();

        this.updateGastoTotal();
      }
    }
  }

  onSave() {
    var gastosPeriodo = [...new Set([
      ...this.gastosComunidadPeriodoList,
      ...this.gastosUfPeriodoList
    ])];

    var r = new SaveGastosPeriodoRequestDto(this.input.ExpensaCabecera.Id, false, gastosPeriodo);
    this.isSaving = true;

    this.expensaService.saveGastosPeriodo(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success) {
        this.dialogRef.close(new DialogExpensaGastosPeriodoComponentResponseDto(false));
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onSimular() {
    var gastosPeriodo = [...new Set([
      ...this.gastosComunidadPeriodoList,
      ...this.gastosUfPeriodoList
    ])];

    var r = new SaveGastosPeriodoRequestDto(this.input.ExpensaCabecera.Id, true, gastosPeriodo);
    this.isSimulating = true;

    this.expensaService.saveGastosPeriodo(r).subscribe(data => {
      this.isSimulating = false;
      if (data != null && data.Success) {
        const dialogRef = this.dialog.open(DialogExpensaLiquidacionSimulacionComponent, {
          width: '95%',
          data: data.Result
        });

        dialogRef.afterClosed().subscribe((result: any) => {
        });
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSimulating = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancel() {
    this.dialogRef.close(new DialogExpensaGastosPeriodoComponentResponseDto(true));
  }
}
